import {
  atom,
  useRecoilState,
  useSetRecoilState,
} from "recoil";

const key = "dashboard-loader";

const dashboardLoaderState = atom({
  key: key,
  default: true,
});

export const useDashboardLoaderState = () =>
  useRecoilState(dashboardLoaderState);
export const useSetDashboardLoaderState = () =>
  useSetRecoilState(dashboardLoaderState);
